import React, { useCallback, useContext, useEffect, useState } from 'react'
import styles from '../styles/table.module.css'
import StateContext from '../context/state/StateContext';


const UserTable = ({ item, index, users, drop, setDrop, setUsers, verified, setVerified }) => {

    const { userUpdateId, setUserUpdateId, setModal, setConfirm } = useContext(StateContext)

    const openDrop = useCallback((index) => {
        setDrop((prevDrop) => {
            const newDrop = [...prevDrop];
            newDrop[index] = !newDrop[index];
            return newDrop;
        });
    }, [setDrop]);

    const verifiedDrop = useCallback((index, verified) => {
        setVerified((prevVerified) => {
            if (prevVerified[index] === verified) return prevVerified;
            const newVerified = [...prevVerified];
            newVerified[index] = verified;
            return newVerified;
        });
        setUsers((prevUser) => {
            const newUser = [...prevUser];
            newUser[index].role = verified;
            return newUser;
        });
        setDrop((prevDrop) => {
            const newDrop = [...prevDrop];
            newDrop[index] = !newDrop[index];
            return newDrop;
        });
    }, [setVerified, setUsers, setDrop]);

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
    };


    return (
        <>
            <tr key={index}>
                <td>0{item.numericalId + 1}</td>
                <td>
                    <div className={styles.user}>
                        {item.picture ? <div className={styles.image}>
                            <img src={process.env.REACT_APP_API_URL + `uploads/${item.picture}`} className='img-fluid' alt="" />
                        </div> : <i class='bx bxs-user-circle' ></i>}
                        <p>{item.name}</p>
                    </div>
                </td>
                <td>
                    <p>{item.username.toLowerCase()}</p>
                </td>
                <td>
                    <p>{item.email}</p>
                </td>
                <td>
                    {item.phone ? <p>{item.phone}</p> : <p>-</p>}
                </td>
                <td>
                    <p>{formatDate(item.created_at)}</p>
                </td>
                <td>
                    <div className={`${styles.dropDown} w-100 ${drop[item.numericalId] ? styles.active : ''}`} onClick={() => openDrop(item.numericalId)}>
                        <p className={`${styles.verified}`}>{verified[item.numericalId] === "agency" ? "Agency User" : verified[item.numericalId] === "employee" ? "Team Member" : verified[item.numericalId]}</p>
                        <ul onClick={() => openDrop(item.numericalId)}>
                            <li onClick={() => {verifiedDrop(item.numericalId, "hod")}}>HOD</li>
                        <li onClick={() => {verifiedDrop(item.numericalId, 'agency')}}>Agency User</li>
                        <li onClick={() => {verifiedDrop(item.numericalId, 'employee')}}>Team Member</li>
                    </ul>
                    </div>
                </td>
                <td>
                    <p className='cursor-pointer text-center' onClick={()=>{setUserUpdateId(item.id);setModal({ open: true, component: "ProfileUpdate" })}}><i className="fa fa-edit" aria-hidden="true"></i></p>
                </td>
                <td>
                    <p className='cursor-pointer text-center' onClick={()=>{setModal({ open: true, component: "Confirm" }); setConfirm({ component: "User", ticketId: item.id, text: `Are you sure you want to delete ${item.username} ?` }) }}><i className="fa fa-trash text-danger" aria-hidden="true"></i></p>
                </td>
            </tr>
        </>
    )
}

export default UserTable


// <td>
//                     <div className={`${styles.dropDown} ${drop[item.numericalId] ? styles.active : ''}`} onClick={() => openDrop(item.numericalId)}>
//                         <p className={`${styles.verified} ${verified[item.numericalId] ? styles.green : styles.red}`}>{verified[item.numericalId] ? 'True' : 'False'}</p>
//                         <ul onClick={() => openDrop(item.numericalId)}>
//                             <li onClick={() => verifiedDrop(item.numericalId, true)}>True</li>
//                             <li onClick={() => verifiedDrop(item.numericalId, false)}>False</li>
//                         </ul>
//                     </div>
//                 </td>